import React, {Component} from 'react';
import HeaderLogo from './header_logo';
import WebsiteHeader from './website_header';
import MobileHeader from './mobile_header';

class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }
  render() {
    const { history } = this.props
    return(
        <div className="wrapper header-logo">
        <div className="logo">
            <a href={`/`}>
                <HeaderLogo />
            </a>
            <WebsiteHeader />
            <MobileHeader />
          </div>
        </div>
    )
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/component/Common/header/index.js